// from https://developer.mozilla.org/en-US/docs/Glossary/Base64

function base64ToBytes(base64: string): Uint8Array {
  const binString = atob(base64);
  return Uint8Array.from(binString as any, (m: any) => m.codePointAt(0));
}

function bytesToBase64(bytes: Uint8Array) {
  const binString = Array.from(bytes, byte => String.fromCodePoint(byte)).join('');
  return btoa(binString);
}

export function encodeUnicodeBase64(input: string): string {
  return bytesToBase64(new TextEncoder().encode(input)).replaceAll(
    /[=+/]/g,
    r => ({ '=': '.', '/': '_', '+': '-' }[r] as string)
  );
}

export function decodeUnicodeBase64(input: string): string {
  return new TextDecoder().decode(
    base64ToBytes(input.replaceAll(/[._-]/g, r => ({ '.': '=', _: '/', '-': '+' }[r] as string)))
  );
}
